import { useHistory } from 'react-router-dom';
import Button from '../../components/common/buttons/Button';
import GameWrapper from '../../components/common/wrappers/GameWrapper';
import PageWrapper from '../../components/common/wrappers/PageWrapper';

export default function ErrorPage() {
    const history = useHistory();

    const onClick = () => {
        history.push({
            pathname: '/',
        });
    };

    return (
        <PageWrapper>
            <div className="error-screen">
                <GameWrapper>
                    <div className="card game-card">
                        <div className="task-title">Chyba</div>
                        <div className="task-text task-text--standalone contact-link">
                            Omlouváme se vám za výpadek, na opravě se už pracuje.
                        </div>
                        <div className="home-link">
                            <Button onClick={onClick} className="primary-button">
                                Zkusit znovu
                            </Button>
                        </div>
                    </div>
                </GameWrapper>
            </div>
        </PageWrapper>
    );
}
